import { Translate } from "components/common/Translate/Translate";
import { ContentItem } from "../ContentItem/ContentItem";
import { ContentParent } from "../ContentParent";
import { PerfectQualityIcon } from "components/common/Icons/PerfectQualityIcon";
import { TrophyIcon } from "components/common/Icons/TrophyIcon";
import { ImageFormatsIcon } from "components/common/Icons/ImageFormatsIcon";
import { ZipIcon } from "components/common/Icons/ZipIcon";
import { PrivacyGuaranteedIcon } from "components/common/Icons/PrivacyGuaranteedIcon";
import { HeartIcon } from "components/common/Icons/HeartIcon";

export const BulkResizerContent = () => {
    return (
        <ContentParent>
            <ContentItem
                title={<Translate keyName="content-easy-title" />}
                description={<Translate keyName="content-easy-sub-title" />}
                icon={<PerfectQualityIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-best-title" />}
                description={<Translate keyName="content-best-sub-title" />}
                icon={<TrophyIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-units-title" />}
                description={<Translate keyName="content-units-sub-title" />}
                icon={<ImageFormatsIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-size-title" />}
                description={<Translate keyName="content-size-sub-title" />}
                icon={<ZipIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-safe-title" />}
                description={<Translate keyName="content-safe-sub-title" />}
                icon={<PrivacyGuaranteedIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-free-title" />}
                description={<Translate keyName="content-free-sub-title" />}
                icon={<HeartIcon />}
            />
        </ContentParent>
    );
};
